<template>
  <div>
    <div style="padding: 30px; padding-top: 0">
      <div class="main-area">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
          <el-form-item label="客户名称" prop="customerName">
            <el-input v-model="form.customerName" placeholder="请填写客户名称">
            </el-input>
            <el-button slot="append" icon="el-icon-s-operation"
              >已有客户</el-button
            >
          </el-form-item>
          <el-form-item label="市场分类" prop="marketType">
            <el-select v-model="form.marketType" placeholder="请选择市场分类">
              <el-option
                v-for="(item, index) in allDictionary['MarketType']"
                :key="index"
                :label="item.dictionaryName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所在地域" prop="regional">
            <el-select
              v-model="form.regional"
              filterable
              placeholder="请选择所在地域"
            >
              <el-option
                v-for="(item, index) in allDictionary['Regional']"
                :key="index"
                :label="item.dictionaryName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <div>
        <el-button @click="resetForm('form')">重 置</el-button>
      </div>

      <div>
        <el-button @click="cancelDialog('form')">取 消</el-button>
        <el-button type="primary" @click="confirmAddition">确定新增</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { CustomerAdd, getCommon } from "@/api/M_ProjectManagement.js";

export default {
  props: ["closeDialog"],
  data() {
    return {
      allDictionary: {}, // 市场分类，地域等信息
      // 新增项目表单
      form: {
        customerName: "",
        marketType: "",
        regional: ""
      },
      rules: {
        customerName: [
          { required: true, message: "请填写客户名称", trigger: "blur" }
        ],
        marketType: [
          { required: true, message: "请填写市场分类", trigger: "change" }
        ],
        regional: [
          { required: true, message: "请填写所在地域", trigger: "change" }
        ]
      }
    };
  },
  activated() {},
  created() {
    this.getMISCommon();
  },
  computed: {},
  mounted() {},
  watch: {},
  methods: {
    // 获取市场分类，地域select
    async getMISCommon() {
      let res = await getCommon();
      let { dict } = res.data;
      dict.forEach((item) => {
        let obj = {
          ...item
        };
        if (this.allDictionary[item.dictionaryType]) {
          this.allDictionary[item.dictionaryType].push(obj);
        } else {
          this.allDictionary[item.dictionaryType] = [obj];
        }
      });
      this.$forceUpdate();
    },

    // 重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    // 确定新增客户
    confirmAddition() {
      this.closeDialog();
      let params = {
        CustomerName: this.form.customerName,
        Regional: this.form.regional,
        MarketType: this.form.marketType
      };
      let formData = new FormData();
      for (let i in params) {
        formData.append(i, params[i]);
      }
      CustomerAdd(formData)
        .then((res) => {
          this.$message.success("新增客户成功");
        })
        .catch((err) => {
          console.warn(err);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },

    cancelDialog(formName) {
      this.$refs[formName].resetFields();
      this.closeDialog();
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-footer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.el-select {
  width: 100%;
}
.main-area {
  position: relative;
}
.el-select-dropdown__item:last-child {
  margin-bottom: 20px;
}
</style>
